<template>
<div>
  <div class="card-row row">
    <div class="card-row-col card-col"
      v-for="(column, index) in sectionHeader"
      :class="column.class"
      v-bind:key="index">
      <Ellipsis v-if="column.truncateOn"
        :text="getTripDetails[column.label]"
        :length="column.truncateOn" />
      <span v-else-if="column.label === 'status'" :class="getTripDetails.statusClass">
       <span class="status">{{getTripDetails[column.label]}}</span>
        <!-- TODO: have to change it as icon-->
        <span v-if="getTripDetails.isAutoComplete">
        <Tooltip class="item" effect="dark" placement="bottom">
          <div slot="content" class="tooltipcontent">Auto Completed</div>
          <button class="iconsection"><span>
          <svgicon name="auto-completed" width="10" height="10" :original="true" />
        </span></button>
        </Tooltip>
        </span>
      </span>
      <span v-else-if="column.label === 'status'" :class="getStatusClass()">{{getTripDetails[column.label]}}</span>
      <span v-else>{{getTripDetails[column.label]}}</span>
    </div>
    <div class="card-row-col card-col action_col tacking_col">
      <div @click="showDetails(index)" class="pointer">
        <svgicon name="details" width="12" height="12" :original="true" />
        <span class="card-actionlabel">DETAILS</span>
      </div>
    </div>
    <div v-if="getTripDetails.isCurrentlyHalted" class="alertinfo alert-notify alert-warning">
    <Alert type="info" trigger="click">
          <ul>
            <li class="el-alert__title is-bold">TRUCK HALT ALERT</li>
          </ul>
        <svgicon class="infosvg" name="info" width="14" height="14" :original="true" />
      </Alert>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { statusList } from '@/constants/tracking';
import moment from 'moment';
import { getDateDiff } from '@/lib/Date';

export default {
  props: {
    trip: {
      type: Object,
      required: true,
    },
    sectionHeader: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      Details: {},
      errorMessage: [],
      tripDetails:{},
      statusList,
    };
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
    }),
    getTripDetails() {
      this.tripDetails = this.trip;
      const extractStatus = this.statusList.find(status=> status.name === this.trip.status)
      this.tripDetails.route = this.trip.source.concat(' - ', this.trip.destination);
      this.tripDetails.statusClass = extractStatus ? extractStatus.color : '';
      this.tripDetails.createdAt = moment( this.trip.created_at).format('DD MMM YYYY');
      return this.tripDetails;
    },
  },
  methods: {
    getStatus(id) {
      return this.statusList.find(i =>  i.id === id );
    },
    getStatusClass() {
      const type = this.getStatus(this.trip.status).color.toLowerCase();
      return `color-${type}`;
    },
    showDetails(index) {
      this.$emit("showDetails", index);
    },
  },
};
</script>

<style lang="scss">

</style>